<template>
  <div class="tags-field">
    <vSelect
      label="name"
      taggable
      :value="tags"
      :filterable="false"
      multiple
      :options="options"
      :on-change="fieldUpdated"
      @search="onSearch"
    />
  </div>
</template>

<script>
  // OBSOLETE: Remove this component to new version without ticket
  import services from '@/services'

  import Issue from './emission-field'

  import vSelect from 'vue-select'

  export default {
    name: 'TagsField',
    components: { vSelect },
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      }
    },
    data() {
      return {
        fieldValue: '',
        options: []
      }
    },
    computed: {
      tags() {
        return (
          this.fieldValue ||
          (this.value.fieldId ? this.value.fieldValue : this.value)
        )
      }
    },
    methods: {
      fieldUpdated(value) {
        this.fieldValue = value

        this.$emit('input', Issue.createField(this.id, this.fieldValue, false))
      },
      onSearch(query, loading) {
        loading(true)

        services.main.searchTags(query).then(result => {
          this.options = result
          loading(false)
        })
      }
    }
  }
</script>

<style>
  .tags-field {
    border-radius: 8px;
    border: 1px solid #ddd;
  }

  .v-select > .dropdown-toggle {
    border: none !important;
  }

  button[title='Clear selection'] {
    display: none;
  }
</style>
